/*eslint-disable*/
import React from 'react';
import {
  Create as RaCreate,
  required,
  TextInput,
  useGetIdentity,
  SimpleForm,
  FormDataConsumer,
  number,
  ReferenceInput,
  SelectInput,
} from 'react-admin';
import { CustomSelect } from './Components/CustomSelect';
import { USER_ROLE } from '../../constants/statuses';

export const Create = (props) => {
  const redirect = (basePath) => `${basePath}`;
  const { loading: identityLoading, identity } = useGetIdentity();

  if (identityLoading) {
    return null;
  }

  const isAdmin =
    identity?.roles && identity.roles.includes(USER_ROLE.SUPER_ADMIN);

  return (
    <RaCreate {...props}>
      <SimpleForm redirect={redirect}>
        <CustomSelect
          source="user"
          optionValue="email"
          optionText="email"
          route="users/list"
          choiceAddField="fullName"
          filter={{'pstid||$notnull':null}}
          isDisabled={!isAdmin}
          customDefaultValue={identity?.email}
          defaultValueField="email"
          validate={required()}
        />
        <CustomSelect
          source="account_id"
          optionValue="id"
          optionText="id"
          label="Account"
          route="library/get-account-list"
          choiceAddField="balance"
          validate={required()}
        />
        <CustomSelect
          source="type"
          optionValue="slug"
          optionText="name"
          route="library/get-types-list"
          choiceAddField="card_price"
          validate={required()}
        />
        <CustomSelect
          source="system"
          optionValue="id"
          optionText="name"
          route="library/get-systems-list"
          validate={required()}
        />
        <FormDataConsumer>
          {({ formData }) => {
            const { type, system } = formData;
            const isDisabled = type && system;
            const filter = { type, system };
            if (!isDisabled) {
              return (
                <span
                  style={{
                    width: '256px',
                    height: '48px',
                    backgroundColor: 'rgb(245, 245, 245)',
                    display: 'flex',
                    marginBottom: '20px',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderBottom: '1px solid grey',
                    color: 'rgb(109 109 109)',
                    userSelect: 'none',
                  }}
                >
                  Please select TYPE and SYSTEM
                </span>
              );
            }
            return (
              <CustomSelect
                source="bin"
                isDisabled={Boolean(!isDisabled)}
                optionValue="id"
                optionText="id"
                route="library/get-bin-list"
                choiceAddField="available_cards"
                filter={filter}
                validate={required()}
              />
            );
          }}
        </FormDataConsumer>
        <TextInput
          source="start_balance"
          label="Start balance"
          validate={[required(), number()]}
          allowEmpty={false}
        />
        <FormDataConsumer>
          {({ formData }) => {
            const { user: userEmail } = formData;
            if (!userEmail) return;
            return (
              <CustomSelect
                source="description"
                filter={{ userEmail }}
                optionValue="name"
                optionText="name"
                label="Geo group"
                route="users/get-geolocation-by-user"
                validate={required()}
              />
            );
          }}
        </FormDataConsumer>
      </SimpleForm>
    </RaCreate>
  );
};
